import React, { FC, useEffect, useState } from "react";
import useFetch from "hooks/useFetch";
import config from "config.json";
import { useNavigate } from "react-router-dom";
import CommonLayout from "./CommonLayout";

interface Condicion {
    id: number;
    codigo: string;
    descripcion: string;
}

interface FamilyMember {
    id: number;
    dni: string;
    apellidoNombre: string;
    condicion: Condicion;
    fechaNacimiento: string;
    usuarioAsociado: number;
}

interface ApiResponse {
    code: string;
    content: FamilyMember[];
}

const formatDate = (dateString: string): string => {
    const months = [
        'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
        'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ];
    const [year, month, day] = dateString.split('-').map(Number);
    return `${day} de ${months[month - 1]} de ${year}`;
};

const FamilyGroup: FC = () => {
    const [familyGroupData, setFamilyGroupData] = useState<FamilyMember[]>([]);
    const { data, isLoading, error, fetchData } = useFetch<ApiResponse>(
        'GET',
        `${config.backend_url}/setia/ocupantes/lista`,
        {},
        {
            'Content-Type': 'application/json',
            'SetiaAuthorization': `${sessionStorage.getItem("user_token")}`
        }
    );
    const navigate = useNavigate();

    useEffect(() => {
        if (data && data.content) {
            console.log(data.content);
            console.log(filterFamilyGroupData(data.content));
            
            setFamilyGroupData(filterFamilyGroupData(data.content));
        }
    }, [data]);

    useEffect(() => {
        fetchData();
    }, []);

    const handleGoBack = () => {
        navigate("/account");
    };

    const filterFamilyGroupData = (familyGroup: FamilyMember[]) => {
        let newFamilyGroup:FamilyMember[] = [];
        familyGroup.forEach((member: FamilyMember) => {
            if ((newFamilyGroup.findIndex((m: FamilyMember) => m.dni === member.dni) === -1) && (member.condicion.codigo !== "AFIL")) {
                newFamilyGroup.push(member);
            }
        })
        return newFamilyGroup;
    };

    if (isLoading) {
        return <div>Loading...</div>;
    }

    if (error || familyGroupData.length === 0) {
        return (
            <div className="container block text-center my-20">
                <p>No pudimos obtener la información de tu grupo familiar.</p>
                <button
                    className="mt-3 ml-4 bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded-full"
                    onClick={handleGoBack}
                >
                    Ir a mi cuenta
                </button>
            </div>
        );
    }

    return (
        <CommonLayout>
        <div className="container block  overflow-auto bg-white p-8 border rounded-2xl">
            {/* <h2 className="text-2xl font-bold mb-4">Mi grupo familiar:</h2> */}
            <table className="table-auto w-full bg-white rounded-md border-gray-300">
                <thead>
                    <tr>
                        <th className="py-2 px-4 border-b font-semibold">DNI</th>
                        <th className="py-2 px-4 border-b font-semibold">Nombre</th>
                        <th className="py-2 px-4 border-b font-semibold">Condición</th>
                        <th className="py-2 px-4 border-b font-semibold">Fecha de Nacimiento</th>
                    </tr>
                </thead>
                <tbody>
                    {familyGroupData.map((item) => (
                        <tr key={item.id} className="">
                            <td className="py-2 px-4 border-b text-center">{item.dni}</td>
                            <td className="py-2 px-4 border-b text-center">{item.apellidoNombre}</td>
                            <td className="py-2 px-4 border-b text-center">{item.condicion.descripcion}</td>
                            <td className="py-2 px-4 border-b text-center">{formatDate(item.fechaNacimiento)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
        </CommonLayout>
    );
};

export default FamilyGroup;